import $ from "jquery";

export class Imagegallery {

    constructor() {
        (<any>window).Imagegallery = this;

        $(document).ready(function () {
            (<any>window).Imagegallery.initImageGallery();
            (<any>window).Imagegallery.initSimpleLightBoxes();
        });

        $(window).on("resize", function () {
            $("#imagegalleryviewer").removeAttr("style");
            $("#imagegalleryviewer").css("top", 0).css("left", 0).css("bottom", 0).css("right", 0).css("min-width", $(window).innerWidth()).css("min-height", $(window).innerHeight());
        });


    }

    initSimpleLightBoxes() {
        $(".lightboxable").each(function () {
            $(this).on("click", function (e) {
                e.preventDefault();

                $("#imagegalleryviewer").remove();
                $("BODY").addClass("imagegalleryopen");

                $("BODY").append(
                    `<div id='imagegalleryviewer' role="dialog" aria-modal="true" tabindex="-1">
                    <img class='image' src='${$(this).attr("href")}' border='0' alt='Großansicht' />
                    <a href='#' class='close' role="button" aria-label="Galerie schließen" tabindex="0">&times;</a>
                </div>`
                );

                $("#imagegalleryviewer").fadeIn(250);
                $("#imagegalleryviewer").on("click", function () {
                    $(this).fadeOut(250, function () {
                        $(this).remove();
                        $("BODY").removeClass("imagegalleryopen");
                    });
                });

                $("#imagegalleryviewer a.close").on("click", function (e) {
                    e.preventDefault();
                    $("#imagegalleryviewer").trigger("click");
                });

                // ESC zum Schließen
                $(document).on("keydown.imagegallery", function (e) {
                    if (e.key === "Escape") {
                        $("#imagegalleryviewer").trigger("click");
                    }
                });

                // Fokus auf Close-Button setzen
                $("#imagegalleryviewer a.close").focus();
            });
        });
    }


    initImageGallery() {
        $(".imagegallery").each(function () {
            const $gallery = $(this);
            $gallery.attr("data-max", $gallery.find("a").length).attr("data-current", "1");

            $gallery.find("a").on("click", function (e) {
                e.preventDefault();

                const $clickedThumb = $(this); // für Rückfokus nach Schließen
                const pos = $clickedThumb.attr("data-pos");
                const src = $clickedThumb.attr("href");
                const title = $clickedThumb.attr("data-title")?.trim() || "";
                const text = $clickedThumb.attr("data-text")?.trim() || "";

                $("#imagegalleryviewer, #imagegallerydesc").remove();
                $("BODY").addClass("imagegalleryopen");

                let titleAndDescription = "";
                if (title || text) {
                    titleAndDescription += title ? `<b>${title}</b>` : "";
                    titleAndDescription += text ? (title ? "<br />" : "") + text : "";
                }

                // HTML-Aufbau mit richtiger Tab-Reihenfolge
                let viewerHTML = `
                <div id='imagegalleryviewer' data-gallery='${$gallery.attr("data-uuid")}' role="dialog" aria-modal="true" tabindex="-1">
                    <a href='#' class='close' role="button" aria-label="Galerie schließen" tabindex="0">&times;</a>
            `;

                if ($gallery.find("a").length > 1) {
                    viewerHTML += `
                    <a href='#' class='prev' role="button" aria-label="Vorheriges Bild" tabindex="0">&lt;</a>
                `;
                }

                viewerHTML += `
                <img class='image' data-pos='${pos}' src='${src}' alt='Großansicht' data-title='${title}' data-text='${text}' />
            `;

                if ($gallery.find("a").length > 1) {
                    viewerHTML += `
                    <a href='#' class='next' role="button" aria-label="Nächstes Bild" tabindex="0">&gt;</a>
                `;
                }

                viewerHTML += `</div>`;

                if (titleAndDescription) {
                    viewerHTML += `<div id='imagegallerydesc'>${titleAndDescription}</div>`;
                }

                $("BODY").append(viewerHTML);
                $("#imagegalleryviewer").fadeIn(250);

                // Beschreibung positionieren
                if (titleAndDescription) {
                    $("#imagegalleryviewer .image").on("load", function () {
                        $("#imagegallerydesc").css({
                            width: $(this).width(),
                            bottom: $(this).offset().top - $(window).scrollTop(),
                            left: $(this).offset().left,
                        }).animate({ opacity: 1 }, 500);
                    });
                }

                // Navigation
                $("#imagegalleryviewer a.prev").on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    (<any>window).Imagegallery.prevGalleryImage();
                });

                $("#imagegalleryviewer a.next").on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    (<any>window).Imagegallery.nextGalleryImage();
                });

                $("#imagegalleryviewer a.close").on("click", function (e) {
                    e.preventDefault();
                    $("#imagegalleryviewer").trigger("click");
                });

                // ESC schließt Galerie
                $(document).on("keydown.imagegallery", function (e) {
                    if (e.key === "Escape") {
                        $("#imagegalleryviewer").trigger("click");
                    }
                });

                // Fokus auf Close-Button setzen
                $("#imagegalleryviewer a.close").focus();

                // Fokusfalle (Focus Trap)
                const focusableSelectors = '#imagegalleryviewer a.close, #imagegalleryviewer a.prev, #imagegalleryviewer a.next';
                const $focusables = $(focusableSelectors).filter(":visible");
                const firstFocusable = $focusables.first()[0];
                const lastFocusable = $focusables.last()[0];

                $(document).on("keydown.imagegallery.tabtrap", function (e) {
                    if (e.key === "Tab" && $focusables.length) {
                        if (e.shiftKey) {
                            // Shift+Tab rückwärts
                            if (document.activeElement === firstFocusable) {
                                e.preventDefault();
                                (lastFocusable as HTMLElement).focus();
                            }
                        } else {
                            // Tab vorwärts
                            if (document.activeElement === lastFocusable) {
                                e.preventDefault();
                                (firstFocusable as HTMLElement).focus();
                            }
                        }
                    }
                });

                // Klick auf Hintergrund schließt Galerie
                $("#imagegalleryviewer").on("click", function () {
                    $("#imagegallerydesc").remove();
                    $(this).fadeOut(250, function () {
                        $(this).remove();
                        $("BODY").removeClass("imagegalleryopen");

                        // Event-Handler entfernen
                        $(document).off("keydown.imagegallery");
                        $(document).off("keydown.imagegallery.tabtrap");

                        // Fokus zurück auf geklicktes Thumbnail
                        if ($clickedThumb && $clickedThumb.length) {
                            $clickedThumb.focus();
                        }
                    });
                });

                // Klick auf Buttons blockiert Schließen
                $("#imagegalleryviewer a").on("click", function (e) {
                    e.stopPropagation();
                });

                (<any>window).Imagegallery.updateGalleryViewButtons();
            });
        });
    }




    prevGalleryImage() {
        var $viewer = $("#imagegalleryviewer");
        var $gallery = $(
            ".imagegallery[data-uuid=" + $viewer.attr("data-gallery") + "]"
        );

        var current = Number($viewer.find("IMG.image").attr("data-pos"));
        current--;
        if (current <= 0) return;

        let $new = $gallery.find("A[data-pos=" + current + "]");
        if ($new.length <= 0) return;

        var titleAndDescription = "";
        if ($new.attr("data-title").trim().length > 0 || $new.attr("data-text").trim().length > 0) {
            titleAndDescription = "";
            if ($new.attr("data-title").trim().length > 0) titleAndDescription = titleAndDescription + "<b>" + $new.attr("data-title").trim() + "</b>";
            if ($new.attr("data-text").trim().length > 0) titleAndDescription = titleAndDescription + ($new.attr("data-title").trim().length > 0 ? "<br />" : "") + $new.attr("data-text").trim();
        }

        $("#imagegallerydesc").remove();
        if (titleAndDescription != "") {
            $("BODY").append("<div id='imagegallerydesc'>" + titleAndDescription + "</div>");
        }

        $viewer
            .find("IMG.image")
            .attr("src", $new.attr("href"))
            .attr("data-pos", $new.attr("data-pos"));

        // If Title and/or Description?!?
        if (titleAndDescription != "") {
            $("#imagegalleryviewer .image").on("load", function () {
                $("#imagegallerydesc").css("width", $("#imagegalleryviewer .image").width());
                $("#imagegallerydesc").css("bottom", $("#imagegalleryviewer .image").offset().top - $(window).scrollTop());
                $("#imagegallerydesc").css("left", $("#imagegalleryviewer .image").offset().left);
                $("#imagegallerydesc").animate({ opacity: 1 }, { duration: 500 });
            });
        }

        (<any>window).Imagegallery.updateGalleryViewButtons();
    }

    nextGalleryImage() {
        var $viewer = $("#imagegalleryviewer");
        var $gallery = $(
            ".imagegallery[data-uuid=" + $viewer.attr("data-gallery") + "]"
        );

        var current = Number($viewer.find("IMG.image").attr("data-pos"));
        current++;
        if (current > Number($gallery.attr("data-max"))) return;

        let $new = $gallery.find("A[data-pos=" + current + "]");
        if ($new.length <= 0) return;

        var titleAndDescription = "";
        if ($new.attr("data-title").trim().length > 0 || $new.attr("data-text").trim().length > 0) {
            titleAndDescription = "";
            if ($new.attr("data-title").trim().length > 0) titleAndDescription = titleAndDescription + "<b>" + $new.attr("data-title").trim() + "</b>";
            if ($new.attr("data-text").trim().length > 0) titleAndDescription = titleAndDescription + ($new.attr("data-title").trim().length > 0 ? "<br />" : "") + $new.attr("data-text").trim();
        }

        $("#imagegallerydesc").remove();
        if (titleAndDescription != "") {
            $("BODY").append("<div id='imagegallerydesc'>" + titleAndDescription + "</div>");
        }

        $viewer
            .find("IMG.image")
            .attr("src", $new.attr("href"))
            .attr("data-pos", $new.attr("data-pos"));

        // If Title and/or Description?!?
        if (titleAndDescription != "") {
            $("#imagegalleryviewer .image").on("load", function () {
                $("#imagegallerydesc").css("width", $("#imagegalleryviewer .image").width());
                $("#imagegallerydesc").css("bottom", $("#imagegalleryviewer .image").offset().top - $(window).scrollTop());
                $("#imagegallerydesc").css("left", $("#imagegalleryviewer .image").offset().left);
                $("#imagegallerydesc").animate({ opacity: 1 }, { duration: 500 });
            });
        }

        (<any>window).Imagegallery.updateGalleryViewButtons();
    }

    updateGalleryViewButtons() {
        var $viewer = $("#imagegalleryviewer");
        var $gallery = $(
            ".imagegallery[data-uuid=" + $viewer.attr("data-gallery") + "]"
        );

        // erstes Element?!?
        if (Number($viewer.find("IMG.image").attr("data-pos")) > 1) {
            $("#imagegalleryviewer .prev").removeClass("disabled");
        } else {
            $("#imagegalleryviewer .prev").addClass("disabled");
        }

        // letztes Element?!?
        if (
            Number($viewer.find("IMG.image").attr("data-pos")) <
            Number($gallery.attr("data-max"))
        ) {
            $("#imagegalleryviewer .next").removeClass("disabled");
        } else {
            $("#imagegalleryviewer .next").addClass("disabled");
        }
    }
}